import { useMutation, useQueryClient } from '@tanstack/react-query';

import { createApprovalRequest } from '../../../common/api/clients/offerApproval.api';
import { queries } from '../../../common/api/queryKeys/queries';

export const useApprovalRequestCreate = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: createApprovalRequest,
        onSuccess: (data) => {
            return Promise.all([
                queryClient.invalidateQueries({ queryKey: queries.offers.list._def }),
                queryClient.invalidateQueries({ queryKey: queries.offers.detail(data.offerId).queryKey }),
            ]);
        },
    });
};
